export const ADMIN_HEADER_HEIGHT = 40
export const ADMIN_SIDEBAR_DRAWER_WIDTH = 210
export const ADMIN_SIDEBAR_DRAWER_WIDTH_CLOSED = 46